module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"SUCCESS":"{component} is successfully saved!","CANCEL":"Cancel","SAVE":"Save","SAVING":"Saving..","ERROR":"Error","CLOSE":"Close"},"ar":{"SUCCESS":"تم حفظ  {component}!","CANCEL":"الغاء","SAVE":" حفظ","SAVING":"..احتفاظ","ERROR":"خطأ","CLOSE":"أغلق"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/dialogs/Save.vue
// module id = 311
// module chunks = 1